import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Pagination, Stack, TextField, Typography } from '@mui/material'
import { cabecerasAdmin, notificar } from '../lib/seguridad';
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useNavigate } from 'react-router-dom';
import AlphabetHeader from '../componentes/AlphabetHeader';
import mobile from '../lib/mobile';
import toast from 'react-hot-toast';
import { ContentCopy } from '@mui/icons-material';
import { limpiarTexto } from '../lib/format';

const ListadoBorradores = ({ busqueda = '' }) => {
    const [empresas, setEmpresas] = useState([]);
    const [search, setSearch] = useState(busqueda);
    const [filteredRows, setFilteredRows] = useState([]);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    // realizar busqueda
    useEffect(() => {
        if (busqueda === '') {
            init();
        } else {
            let newEmpresas = empresas.filter((empresa) => empresa.nombre.toLowerCase().includes(busqueda.toLowerCase()) || empresa.nombre_comercial.toLowerCase().includes(busqueda.toLowerCase()));
            setFilteredRows(newEmpresas);
        }
        //setEmpresas()
    }, [busqueda]);

    const init = async () => {
        try {
            await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/empresas_borradores?page=${page}`, { headers: await cabecerasAdmin() })
                .then(res => res.json())
                .then((respuesta) => {
                    if (!respuesta.data || !respuesta.data.empresas) { notificar(respuesta); return; }
                    setEmpresas(respuesta.data.empresas_completas);
                    setFilteredRows(respuesta.data.empresas);
                });
        } catch (error) {
            //console.log(error);
            //alert(error);
        }
    }

    useEffect(() => {
        init();
        setIsMobile(mobile());
    }, []);

    const [selectedProfile, setSelectedProfile] = useState({ token: '' });
    const columns = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 250, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        {/* <Typography variant="body1" noWrap>{params.row.descripcion}</Typography> */}
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.localidad}, {empresa.municipio}, {empresa.estado}</Typography>
                        {/* <Link to={`/empresas/${empresa.nombre}`}> */}
                        <Typography sx={{ mt: 6, "& :hover": { cursor: 'pointer' } }} color="#404555">{'Detalle >'}</Typography>
                        {/* </Link> */}
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'status',
            headerName: '',
            width: 100,
            renderCell: (params) => {
                return (
                    <Box>
                        <Chip label={params.row.status == 0 ? 'Borrador' : 'Publicado'} color={params.row.status == 0 ? 'warning' : 'success'} />
                    </Box>
                )
            }
        },
        {
            field: '',
            renderCell: (params) => {
                return (
                    <Stack direction='row' alignItems="center">
                        {params.row.status == 0 &&
                            <Button onClick={(e) => {
                                e.stopPropagation()
                                handleOpenPublish(params.row.id);
                            }} color="success" size="small">Publicar</Button>
                        }
                        {params.row.status == 1 &&
                            <Button onClick={(e) => {
                                e.stopPropagation()
                                handleOpenHide(params.row.id);
                            }} color="secondary" size="small">Ocultar</Button>
                        }
                        <Button
                            color="warning"
                            onClick={(e) => {
                                e.stopPropagation()
                                setSelectedId(params.id);
                                setSelectedProfile(params.row);
                                setOpenEdit(true);
                            }}
                        >
                            Editar
                            {/* <Typography>Token de edición: {params.row.token}</Typography>
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(params.row.token);
                                    toast.success("¡Token copiado!")
                                }}
                            >
                                <ContentCopy />
                            </IconButton> */}
                        </Button>
                        <Button onClick={(e) => {
                            e.stopPropagation()
                            handleOpenDelete(params.row.id);
                        }} color="error" size="small">Eliminar</Button>

                    </Stack>
                )
            },
            //flex: 1,
            width: 250
        }
    ]

    const columnsSmall = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 100, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.municipio}, {empresa.estado}</Typography>
                    </Box>
                )
            }
        },
        {
            field: '',
            renderCell: (params) => {
                return (
                    <Stack direction='row'>
                        <Button onClick={(e) => {
                            e.stopPropagation()
                            handleOpenPublish(params.row.id);
                        }} color="success" size="small">Publicar</Button>
                        <Button onClick={(e) => {
                            e.stopPropagation()
                            handleOpenDelete(params.row.id);
                        }} color="error" size="small">Eliminar</Button>
                    </Stack>
                )
            },
            //flex: 1,
            width: 175
        }
    ]

    const [openPublish, setOpenPublish] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openHide, setOpenHide] = useState(false);

    const [selectedId, setSelectedId] = useState(null);


    const handleOpenHide = (id) => {
        setSelectedId(id);
        setOpenHide(true);
    }
    const handleOpenPublish = (id) => {
        setSelectedId(id);
        setOpenPublish(true);
    }
    const handleOpenDelete = (id) => {
        setSelectedId(id);
        setOpenDelete(true);
    }

    const handlePublish = async (id) => {
        const body = new FormData;
        body.append("id", parseInt(id));
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/publicar_empresa`, { method: 'POST', body: body, headers: await cabecerasAdmin() })
            .then(res => res.json())
            .then((respuesta) => {
                notificar(respuesta);
                setOpenPublish(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1300)
            })
    }
    const handleDelete = async (id) => {
        const body = new FormData;
        body.append("id", parseInt(id));
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/eliminar_empresa`, { method: 'POST', body: body, headers: await cabecerasAdmin() })
            .then(res => res.json())
            .then((respuesta) => {
                notificar(respuesta);
                setOpenDelete(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1300)
            })
    }
    const handleHide = async (id) => {
        const body = new FormData;
        body.append("id", parseInt(id));
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/ocultar_empresa`, { method: 'POST', body: body, headers: await cabecerasAdmin() })
            .then(res => res.json())
            .then((respuesta) => {
                notificar(respuesta, "Empresa oculta");
                setOpenDelete(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1300)
            })
    }

    const handleLetterClick = (filteredRows) => {
        setFilteredRows(filteredRows);
    };

    // para la paginacion
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const handleChangePage = (e, v) => setPage(v);
    useEffect(() => {
        const get = async () => {
            const url = `https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/empresas_borradores?page=${page}`;
            await fetch(url, { headers: await cabecerasAdmin() })
                .then((res) => res.json())
                .then((respuesta) => {
                    if (!respuesta.data || !respuesta.data.empresas) { notificar(respuesta); return; }
                    //setEmpresas(respuesta.data.empresas);
                    setFilteredRows(respuesta.data.empresas);
                    setTotalPages(respuesta.data.cant_paginas);
                });
        }
        get();
    }, [page]);


    const [openEdit, setOpenEdit] = useState(false);
    return (
        <Box sx={{ m: 2 }}>
            {/* En celular, mostrar  un boton para ir a https://https://empresas-economiasocialysolidaria.com.mx/ */}

            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <AlphabetHeader rows={empresas} onLetterClick={handleLetterClick} />
                <DataGrid
                    rowHeight={150}
                    columns={columns}
                    rows={filteredRows}
                    onRowClick={(params, e, v) => {
                        // enviar a https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/nombre-empresa
                        if (!e.target.innerText.toLowerCase().includes('token')) {
                            let t = params.row.nombre_comercial.toLowerCase()
                            t = t.split(' ').join('-')
                            let nombre = limpiarTexto(t);
                            window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                        }
                        //navigate(`/empresas/${params.row.nombre}`);
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
                <DataGrid
                    rowHeight={100}
                    columns={columnsSmall}
                    rows={filteredRows}
                    onRowClick={(params) => {
                        if (!isMobile) {

                            let t = params.row.nombre_comercial.toLowerCase()
                            t = t.split(' ').join('-')
                            let nombre = limpiarTexto(t);
                            window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                        } else {
                            navigate(`/empresas/${params.row.nombre}`);
                        }
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Pagination count={totalPages} page={page} onChange={handleChangePage} />
            </Box>
            {/* Modales para confirmar publicacion y eliminacion */}
            <Dialog open={openPublish}>
                <DialogTitle>
                    Publicar empresa
                </DialogTitle>
                <DialogContent>
                    <Typography>Al confirmar, la empresa será visible al público.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="contained" onClick={() => { setOpenPublish(false); setSelectedId(null); }}>
                        Cancelar
                    </Button>
                    <Button color="success" variant="contained" onClick={() => handlePublish(selectedId)}>
                        Publicar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openDelete}>
                <DialogTitle>
                    Eliminar empresa
                </DialogTitle>
                <DialogContent>
                    <Typography>Al confirmar, la empresa será eliminada permanentemente.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="success" variant="contained" onClick={() => { setOpenDelete(false); setSelectedId(null); }}>
                        Cancelar
                    </Button>
                    <Button color="error" variant="contained" onClick={() => handleDelete(selectedId)}>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Modal para mostrar guía de edición */}

            <Dialog
                sx={{
                    // marginTop: '-150px',
                    '.MuiDialog-container': {
                        height: 'auto',
                        marginTop: '1px'
                    }
                }}
                open={openEdit} onClose={() => setOpenEdit(false)} >
                <DialogTitle>
                    Editar empresa
                </DialogTitle>
                <DialogContent>
                    <Typography>Para editar la empresa, en la siguiente página haz click en el botón de editar e ingresa el siguiente token:</Typography>
                    <TextField fullWidth sx={{ my: 2 }} variant="outlined" value={selectedProfile.token} label="Token" InputProps={{
                        endAdornment:
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(selectedProfile.token);
                                    toast.success("¡Token copiado!")
                                }}
                            >
                                <ContentCopy />
                            </IconButton>
                    }} />
                    {/* Imagen mostrando el boton de edicion */}
                    <img width="100%" src="/editar.png" alt="Guía edición" />
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="contained" onClick={() => { setOpenEdit(false); setSelectedId(null); }}>
                        Cancelar
                    </Button>
                    <Button color="success" variant="contained" onClick={() => {
                        navigator.clipboard.writeText(selectedProfile.token);
                        toast.success("¡Token copiado!")
                        setSelectedId(null);
                        setSelectedProfile({ token: '' });
                        setOpenEdit(false);
                        // abrir empresa
                        let t = selectedProfile.nombre_comercial.toLowerCase()
                        t = t.split(' ').join('-')
                        let nombre = limpiarTexto(t);
                        window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                    }}>
                        Entiendo y deseo continuar
                    </Button>
                </DialogActions>
            </Dialog>


            {/* Modal para confirmar ocultación (despublicar) */}
            <Dialog open={openHide}>
                <DialogTitle>
                    Ocultar empresa
                </DialogTitle>
                <DialogContent>
                    <Typography>Al confirmar, la empresa será removida del listado público hasta que se vuelva a publicar.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="success" variant="contained" onClick={() => { setOpenHide(false); setSelectedId(null); }}>
                        Cancelar
                    </Button>
                    <Button color="error" variant="contained" onClick={() => handleHide(selectedId)}>
                        Ocultar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ListadoBorradores